/* @flow */
import cx from 'classnames';
import * as React from 'react';
import Link from 'components/Link';
import Glyph from 'components/Glyph';
import Image from 'components/Image';
import ModalTrigger from 'components/ModalTrigger';
import ImageFilePreviewModal from 'components/ImageFilePreviewModal';

import './styles/MessageItemImageAttachment.scss';

const MAX_IMAGE_PREVIEW_HEIGHT = 300;

function getPreviewDimensions(file: FileGQL): { height?: number, width?: number } {
  const height = Math.min(file.previewHeight || 0, MAX_IMAGE_PREVIEW_HEIGHT);
  const width = Math.min(file.previewHeight || 0, MAX_IMAGE_PREVIEW_HEIGHT);

  if (height && width) {
    return { height, width };
  } else {
    return {};
  }
}

type Props = {
  file: FileGQL,
};

const isServerRendered = typeof window === 'undefined';

class MessageItemImageAttachment extends React.Component<Props, *> {
  state = {
    loading: !isServerRendered,
  };

  // NOTE: This is a hack to prevent images from breaking the scrolled-to-bottom behavior of the
  // conversation view. This wouldn't be necessary if images were rendered with dimensions (need
  // dimensions from the backend). This causes a little bit of jank (a bit of a flash when the
  // image loads).
  handleImageOnLoad = () => {
    this.setState({ loading: false });
  };

  render() {
    const { file } = this.props;
    const { url } = file;

    let placeholder = null;
    if (this.state.loading) {
      const dimensions = getPreviewDimensions(file);
      const lineHeight = dimensions.height ? { lineHeight: `${dimensions.height}px` } : {};

      placeholder = (
        <Link
          style={{ ...dimensions, ...lineHeight }}
          className="MessageItemImageAttachment-icon"
          target="_blank"
          eventElementName="MessageItemImageAttachment-icon">
          <Glyph name="image" size="xxxlarge" solo />
        </Link>
      );
    }

    const modal = <ImageFilePreviewModal file={file} />;

    return (
      <div
        className={cx({
          MessageItemImageAttachment: true,
          'MessageItemImageAttachment-loading': this.state.loading,
        })}>
        {placeholder}
        <ModalTrigger modal={modal}>
          <Link
            className="MessageItemImageAttachment-link"
            eventElementName="MessageItemImageAttachment-link">
            <Image
              className="MessageItemImageAttachment-image"
              style={{ maxHeight: MAX_IMAGE_PREVIEW_HEIGHT }}
              onLoad={this.handleImageOnLoad}
              src={url}
            />
          </Link>
        </ModalTrigger>
      </div>
    );
  }
}

export default MessageItemImageAttachment;
